export default "/credits/business/assets/01a58913b2f82277fe7878a0f154638b.png";